import { render, staticRenderFns } from "./confirmation-dialog.vue?vue&type=template&id=065f432f&"
import script from "./confirmation-dialog.vue?vue&type=script&lang=ts&"
export * from "./confirmation-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Dialog: require('/home/vsts/work/1/s/frontend/components/dialog.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
